import ApprovalFormat from "./ApprovalFormat";
import LoginPage from "./Login";
import { BrowserRouter as Router, Route, Routes, HashRouter, Navigate, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

import Login from "./Pages/Login/Login";
import MainPage from "./Pages/MainPage/MainPage";
import Dashboard from "./Pages/Dashboard/Dashboard";
import ExportSheete from "./Pages/ExportSheete/ExportSheete";
import { ToastContainer } from "react-toastify";
import '@progress/kendo-theme-default/dist/all.css';
import MyRequestViewPage from "./Pages/MyRequestViewPage/MyRequestViewPage";
import MyApprovalPendingList from "./Pages/MyApprovalPendingList/MyApprovalPendingList";
import PermitBasicPage from "./Pages/PermitBasic/PermitBasicPage";
import PermitMasterDetail from "./Pages/PermitMasterDetail/PermitMasterDetail";
import PermitViewPage from "./Pages/PermitViewPage/PermitViewPage";
import ViewApprovalPage from "./Pages/ViewApprovalPage/ViewApprovalPage";
import ExtensionApproval from "./Pages/ExtensionApproval/ExtensionApproval";
import {
    useQuery,
    useMutation,
    useQueryClient,
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query'

function App() {

    const queryClient = new QueryClient()
    const [token, setToken] = useState(true);
    const [user, setUser] = useState("");
    const [UserInfo] = useState(JSON.parse(sessionStorage.getItem("UserInfo")))



    useEffect(() => {
        // if (JSON.parse(sessionStorage.getItem("UserInfo")) === null) {
        //     // Routing()
        //     let redirectUrl = window.location.protocol
        //     window.location.href = redirectUrl
        // }
        if (window.location.href.split("/#/")[1].length > 0 && JSON.parse(sessionStorage.getItem("UserInfo")) === null && window.location.href.split("/#/") !== window.location.origin) {
            // Routing()
            let redirectUrl = window.location.protocol
            window.location.href = redirectUrl
        }
    }, [JSON.parse(sessionStorage.getItem("UserInfo"))])



    const Routing = () => {
        if (JSON.parse(sessionStorage.getItem("UserInfo")) === null) {
            return (
                <Routes>
                    <Route path="/" element={<Login />} />
                </Routes>
            )
        }
        else {
            return (
                <>
                    <MainPage>
                        <Routes>
                            <Route path="ExportSheete" element={<ExportSheete />} />
                            <Route path="" element={<Dashboard />} />
                            <Route path="BasicPermit" element={<PermitBasicPage />} />
                            <Route path="PermitMaster" element={<PermitMasterDetail />} />
                            <Route path="PermitApproverMaster" element={<PermitMasterDetail />} />
                            <Route path="PermitViewPage" element={<PermitViewPage />} />
                            <Route path="PermitApprovePage" element={<PermitViewPage />} />
                            <Route path="ExtensionApprovePage" element={<PermitViewPage />} />
                            <Route path="ViewApprovalPage" element={<ViewApprovalPage />} />
                            <Route path="ExtensionApprovalPage" element={<ExtensionApproval />} />
                            {/* <Route path="ApproveListPage" element={<MyApprovalPendingList />} /> */}
                            {/* <Route path="View" element={<MyRequestViewPage />} /> */}
                        </Routes>
                    </MainPage>
                </>

            )
        }
    }
    return (
        <div className="App">
            <QueryClientProvider client={queryClient}>
                <HashRouter>
                    <ToastContainer
                        position="top-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                    />
                    <Routing />
                </HashRouter>
            </QueryClientProvider>
        </div>
    )
}

export default App;